import { apiAxiosInstance, post, get } from "./handler";
export const addRegister = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/add",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportRegister = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/export",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkDupEarthQuake = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/checkDupEarthQuake",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportContract = async () => {
  try {
    const result = await get(
      "/regisEarthQuake/contract",
      undefined,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportCidToDebtTracking = async (payload) => {
  try {
    const result = await post(
      "/regisHc/sendToDebtTracking",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportCidToReverseDebtTracking = async (payload) => {
  try {
    const result = await post(
      "/regisHc/reverseCidTracking",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkDupHcOa = async (payload) => {
  try {
    const result = await post(
      "/regisHc/checkDupHcOa",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
